import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { PauseCircle, CheckCircle, RemoveCircleOutline } from '@mui/icons-material';
import { PROJECT_STATUS_MODAL_CONFIG } from '../../shared/appConstants';
import './ProjectStatusModal.scss';

const ProjectStatusModal = ({ open, onClose, onActivate, loading = false, projectStatus, contentOverride = null }) => {
  const { t } = useTranslation();

  const defaultConfig = projectStatus ? PROJECT_STATUS_MODAL_CONFIG[projectStatus] : null;
  const config = {
    icon: contentOverride?.icon || defaultConfig?.icon,
    colorClass: contentOverride?.colorClass || defaultConfig?.colorClass,
    title: contentOverride?.title || (defaultConfig ? t(defaultConfig.titleKey) : ''),
    message: contentOverride?.message || (defaultConfig ? t(defaultConfig.messageKey) : ''),
    actionLabel: contentOverride?.actionLabel || (defaultConfig ? t(defaultConfig.actionKey) : ''),
    loadingLabel: contentOverride?.loadingLabel || (defaultConfig ? t(defaultConfig.loadingKey) : '')
  };
  if (!config.icon || !config.colorClass || !config.title) return null;

  const IconComponent = config.icon === 'PauseCircle'
    ? PauseCircle
    : config.icon === 'RemoveCircleOutline'
      ? RemoveCircleOutline
      : CheckCircle;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="project-status-modal"
      disableEscapeKeyDown={loading}
    >
      <DialogContent className="project-status-content">
        <Box className={`project-status-icon ${config.colorClass}`}>
          <IconComponent />
        </Box>
        <Typography variant="h4" className="project-status-title">
          {config.title}
        </Typography>
        <Typography className="project-status-message">
          {config.message}
        </Typography>
      </DialogContent>
      <DialogActions className="project-status-actions">
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
          className="cancel-button"
        >
          {t('common.cancel')}
        </Button>
        <Button
          onClick={onActivate}
          variant="contained"
          disabled={loading}
          className={`activate-button ${config.colorClass}`}
        >
          {loading ? config.loadingLabel : config.actionLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectStatusModal;
